// @flow
import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { findById } from '../utils/arrayUtils'
import styles from './categoryTags.less'
import * as actions from '../actions'
import { getVerticals } from '../selectors'

class VerticalsSelect extends Component {
  props: {
    // action creators
    fetchVerticalsIfNeeded: Function,
    putVertical: Function,
    // from state
    options: Array<Object>,
    value: ?{
      name: string,
      id: number,
    },
    industryValue: ?{
      name: string,
      id: number,
    },
    isFetching: boolean,
    id: number,
    disabled: boolean,
    isPutting: boolean,
    putVerticalError: Object,
  }
  state: {
    value: ?Object,
    industryValue: ?Object,
    industryOptions: Array<Object>,
  }
  industryInput: ?HTMLInputElement

  componentWillMount() {
    this.props.fetchVerticalsIfNeeded()
  }

  componentWillReceiveProps({ putVerticalError }) {
    if (putVerticalError) {
      this.setState({ value: null })
    }
  }

  render() {
    const {
      id,
      isFetching,
      options,
      value,
      industryValue,
      isPutting,
      putVerticalError,
      putVertical,
    } = this.props
    let newVal = value
    let newIndustryVal = industryValue
    let newIndustryOptions = !isEmpty(options) && value
      ? findById(options, value.id).industries
      : []
    if (this.state && this.state.value) {
      newVal = this.state.value
      if (this.state.industryValue) {
        newIndustryVal = this.state.industryValue
      }
      if (this.state.industryOptions) {
        newIndustryOptions = this.state.industryOptions
      }
    }
    return (
      <div className={styles.select}>
        <Select
          name="vertical"
          isLoading={isFetching || isPutting}
          placeholder="Select a vertical for this org"
          options={options}
          value={newVal}
          labelKey="name"
          valueKey="id"
          onChange={value => {
            if (this.industryInput) {
              this.industryInput.focus()
            }
            this.setState({
              value,
              industryOptions: value.industries,
              industryValue: {},
            })
          }}
        />
        <dl style={{ marginTop: '10px', marginLeft: '-180px' }}>
          <dt>Vertical Industry</dt>
          <dd>
            <Select
              name="vertical"
              ref={input => (this.industryInput = input)}
              isLoading={isFetching || isPutting}
              placeholder="Select an industry for this org"
              options={newIndustryOptions}
              value={newIndustryVal}
              labelKey="name"
              valueKey="id"
              onChange={value =>
                this.setState({ industryValue: value, value: newVal })}
              onBlur={() => {
                const industryId = newIndustryVal ? newIndustryVal.id : null
                const verticalId = newVal ? newVal.id : null
                putVertical({
                  orgId: id,
                  verticalId,
                  industryId,
                })
              }}
            />
          </dd>
        </dl>
        {putVerticalError
          ? <div className="bg-danger">
              Error: {putVerticalError.response}
            </div>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state, { value, industryValue }) => {
  const { isPutting, putVerticalError, isFetching, items } = getVerticals(state)
  return {
    isFetching,
    isPutting,
    putVerticalError,
    options: items,
    value,
    industryValue,
  }
}

export default connect(mapStateToProps, actions)(VerticalsSelect)



// WEBPACK FOOTER //
// ./src/components/VerticalSelect.js